import { emptyArray, emptyObject } from 'ui-components/default-props/empty';
import { FreightShipmentSortColumn, OrderByDirection } from '@shipstation/client-common/types/freight-requests';
import type { FreightGridStatusCountsResponse } from '@shipstation/client-common/types/freight-responses';

import type { GridState } from './ltl.grid.reducer';

export const selectCurrentPageFulfillmentPlanIds = (state: GridState) => state.currentPageFulfillmentPlanIds ?? emptyArray;
export const selectCurrentPageFreightShipmentIds = (state: GridState) => state.currentPageFreightShipmentIds ?? emptyArray;
export const selectPage = (state: GridState) => state.page ?? 1;
export const selectPageSize = (state: GridState) => state.pageSize ?? 50;
export const selectTotalRecords = (state: GridState) => state.totalRecords ?? 0;
export const selectTotalPages = (state: GridState) => state.totalPages ?? 0;
export const selectIsLoading = (state: GridState) => state.isLoading ?? false;
export const selectHasLoadError = (state: GridState) => state.hasLoadError ?? false;
export const selectSelectedFulfillmentPlanIds = (state: GridState) => state.selectedFulfillmentPlanIds ?? emptyArray;
export const selectActiveFilters = (state: GridState) => state.activeFilters ?? emptyObject;
export const selectAppliedFilters = (state: GridState) => state.appliedFilters ?? emptyArray;
export const selectStatusFilter = (state: GridState) => state.statusFilter ?? null;
export const selectSearchTerm = (state: GridState) => state.searchTerm ?? '';
export const selectSearchPerformed = (state: GridState) => state.searchPerformed ?? false;
export const selectSearchCounts = (state: GridState) => (state.searchCounts ?? emptyObject) as FreightGridStatusCountsResponse;
export const selectIsLoadingSearchCounts = (state: GridState) => state.isLoadingSearchCounts ?? false;
export const selectOrderBy = (state: GridState) => state.orderBy ?? FreightShipmentSortColumn.CreateDateUtc;
export const selectOrderByDirection = (state: GridState) => state.orderByDirection ?? OrderByDirection.Descending;
